import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import ErrorShower from '../ui-utils/error-shower';

const Wrapper = styled.div`
  width: 100%;
`;

const ButtonCard = styled.div.attrs(() => ({}))<{ selected: boolean; inactive: boolean }>`
  width: 100%;
  height: 56px;
  cursor: ${(props) => (props.inactive ? 'not-allowed' : 'pointer')};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  background: var(--matt-bg-color);
  font-weight: ${(props) => (props.selected ? 'bold' : 'initial')};
  border: ${(props) =>
    props.selected ? '2px solid var(--primary-color)' : '0px solid var(--matt-bg-color)'};
  box-shadow: ${(props) => (props.selected ? '0px 0px 20px rgba(0, 102, 255, 0.4)' : 'initial')};
  &:hover {
    background: ${(props) =>
      props.inactive ? 'var(--matt-bg-color)' : 'var(--matt-bg-color-bluish)'};
  }
  & > * {
    cursor: ${(props) => (props.inactive ? 'not-allowed' : 'pointer')};
    color: ${(props) => (props.inactive ? 'var(--gray-text-color)' : '')};
  }
`;

export type ButtonSelectOption = {
  label: string;
  value: string;
};

const ButtonSelect = (props: {
  options: ButtonSelectOption[];
  onSelect: (option: ButtonSelectOption) => void;
  initialValue?: string;
  className?: string;
  inactive?: boolean;
  error?: string;
}): JSX.Element => {
  const [selected, setSelected] = useState<ButtonSelectOption | undefined>(
    props.options.find((o) => o.value === props.initialValue),
  );

  useEffect(() => {
    if (props.initialValue !== selected?.value) {
      setSelected(props.options.find((o) => o.value === props.initialValue));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.initialValue]);

  const handleSelect = (option: ButtonSelectOption): void => {
    if (!props.inactive) {
      setSelected(option);
      if (props.onSelect) {
        props.onSelect(option);
      }
    }
  };
  return (
    <Wrapper className={props.className}>
      <div className="grid gap-3 grid-cols-2">
        {props.options.map((o: ButtonSelectOption, index: number) => (
          <ButtonCard
            key={index}
            selected={!!(selected && o.value === selected.value)}
            onClick={() => handleSelect(o)}
            inactive={!!props.inactive}
          >
            <label className="text-12">{o.label}</label>
          </ButtonCard>
        ))}
      </div>
      <ErrorShower error={props.error} />
    </Wrapper>
  );
};

export default ButtonSelect;
